require('./RAStrategyItem.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @utilites
const { formatText, FormattedText } = require('core/i18n').i18n;

// @assets
const checkIcon = require('../../../assets/images/strategy-buildings/check-selected.svg');

class RAStrategyItem extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const { disabled, id } = this.props;
        if (!disabled) {
            this.props.selectStrategy(id);
        }
    }

    buildTooltip() {
        const tooltipContainer = (
            <div className="ra-strategy-item__tooltip-container" />
        );
        return (
            <OKTooltip
                target={tooltipContainer}
                content="raStrategyItem-outOfBoundTooltip"
            />
        );
    }

    buildModifyTooltip(content, firstCardSelected) {
        const buildingCity = formatText(
            `raStrategyItem-raStrategyItem_${firstCardSelected}`,
        );
        const contentFormatted = (
            <div className="ra-strategy-item__modify-tooltip">
                <FormattedTextWithComponents
                    value={content}
                    injectedComponents={[buildingCity]}
                />
            </div>
        );
        const tooltipContainer = (
            <div className="ra-strategy-item__modify-tooltip-container" />
        );

        return (
            <OKTooltip
                target={tooltipContainer}
                content={contentFormatted}
                placement="bottom"
                modifier="dark-bg"
            />
        );
    }

    buildDetailsButton() {
        return (
            <section className="ra-strategy-item__link-button">
                <OKButton
                    modifier="link-emphasize"
                    inverse={false}
                    onClick={this.props.onStrategyDetailsClick}
                >
                    <FormattedText value="raStrategyItem-seeDetails" />
                </OKButton>
            </section>
        );
    }

    render() {
        const {
            disabled,
            id,
            selectedCard,
            firstCardSelected,
            modifyPlan,
            riskType,
            countryLabel,
        } = this.props;

        const currentClassname = classnames('ra-strategy-item', {
            'ra-strategy-item--is-disabled': disabled,
        });

        const containerClassname = classnames(`ra-strategy-item__container`, {
            [`ra-strategy-item__building-${id}__selected`]: selectedCard === id,
            [`ra-strategy-item__building-${id}__available`]:
                selectedCard !== id,
            [`ra-strategy-item__building-${id}__available__active`]:
                selectedCard !== id && !disabled,
        });

        const countrySelectedClassname = classnames(
            `ra-strategy-item__building-${id}__available__country`,
            {
                [`ra-strategy-item__building-${id}__available__country__selected`]:
                    selectedCard === id,
            },
        );

        const imgSelectedClassname = classnames(
            `ra-strategy-item__building-${id}__available__img`,
            {
                [`ra-strategy-item__building-${id}__available__img__selected`]:
                    selectedCard === id,
            },
        );

        const riskTypeTextClassname = classnames(
            `ra-strategy-item__building-${id}__available__risk`,
        );

        const minContent = 'raStrategyItem-raStrategyItem_minTooltip';
        const maxContent = 'raStrategyItem-raStrategyItem_maxTooltip';
        const tooltip = disabled ? this.buildTooltip() : null;
        const seeDetails =
            !modifyPlan && selectedCard === id
                ? this.buildDetailsButton()
                : null;
        const maxTooltip =
            modifyPlan && selectedCard === id && firstCardSelected < id
                ? this.buildModifyTooltip(maxContent, firstCardSelected)
                : null;
        const minTooltip =
            modifyPlan && selectedCard === id && firstCardSelected > id
                ? this.buildModifyTooltip(minContent, firstCardSelected)
                : null;

        return (
            <div className={currentClassname}>
                {tooltip}
                {maxTooltip}
                {minTooltip}
                <div className={containerClassname} onClick={this.handleClick}>
                    <p className={riskTypeTextClassname}>{riskType}</p>
                    <p className={countrySelectedClassname}>{countryLabel}</p>
                    <img className={imgSelectedClassname} src={checkIcon}></img>
                </div>
                {seeDetails}
            </div>
        );
    }
}

RAStrategyItem.propTypes = {
    disabled: PropTypes.bool,
    firstCardSelected: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
    modifyPlan: PropTypes.bool.isRequired,
    onStrategyDetailsClick: PropTypes.func,
    riskType: PropTypes.string.isRequired,
    selectedCard: PropTypes.number.isRequired,
    selectStrategy: PropTypes.func.isRequired,
    countryLabel: PropTypes.string.isRequired,
};

RAStrategyItem.defaultProps = {
    disabled: false,
};

module.exports = RAStrategyItem;
